import { api } from './authService';

// Asumimos que tienes un endpoint en tu backend que devuelve solo los técnicos.
// Si no, podrías llamar a '/users' y filtrar por rol en el frontend.
const getTechnicians = (params = {}) => {
  return api.get('/users/technicians', { params });
};

/**
 * @description Obtiene el listado completo de técnicos (id + username), sin paginar.
 * Pensado para poblar selects/dropdowns — a diferencia de getTechnicians(), no está
 * sujeto al límite de página (máx. 100) del endpoint tabular, por lo que no se rompe
 * a medida que crece la cantidad de técnicos.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con { data: [{user_id, username}] }.
 */
const getTechniciansLookup = () => {
  return api.get('/users/technicians/lookup');
};

/**
 * @description Obtiene la lista completa de usuarios desde la API.
 * Requiere rol ADMIN o SUPERVISOR.
 * @returns {Promise<import('axios').AxiosResponse>}
 */
const getUsers = (params = {}) => {
  return api.get('/users', { params });
};

/**
 * @description Crea un nuevo usuario. Requiere JWT con rol ADMIN.
 * Usa POST /users (no /auth/register) para poder asignar cualquier rol de forma segura.
 * @param {object} userData - Datos del nuevo usuario (username, email, password, role, phone, position).
 * @returns {Promise<import('axios').AxiosResponse>}
 */
const createUser = (userData) => {
  return api.post('/users', userData);
};

/**
 * @description Actualiza los datos de un usuario existente.
 * Solo accesible por ADMIN.
 * @param {number} id - ID del usuario a actualizar.
 * @param {object} userData - Campos a modificar (sin password).
 * @returns {Promise<import('axios').AxiosResponse>}
 */
const updateUser = (id, userData) => {
  return api.patch(`/users/${id}`, userData);
};

/**
 * @description Cambia el rol de un usuario. Solo accesible por ADMIN y nunca sobre
 * el propio usuario (el backend responde 403). El historial del usuario conserva
 * el rol con el que registró cada actividad.
 * @param {number} id - ID del usuario.
 * @param {string} role - Nuevo rol: ADMIN | SUPERVISOR | TECHNICIAN.
 * @returns {Promise<import('axios').AxiosResponse>}
 */
const changeUserRole = (id, role) => {
  return api.patch(`/users/${id}/role`, { role });
};

/**
 * @description Elimina un usuario por su ID.
 * Solo accesible por ADMIN.
 * @param {number} id - ID del usuario a eliminar.
 * @returns {Promise<import('axios').AxiosResponse>}
 */
const deleteUser = (id) => {
  return api.delete(`/users/${id}`);
};

const userService = {
  getTechnicians,
  getTechniciansLookup,
  getUsers,
  createUser,
  updateUser,
  changeUserRole,
  deleteUser,
};

export default userService;
